import { render, staticRenderFns } from "./RubricPresetUnitForm.vue?vue&type=template&id=68597adf&scoped=true"
import script from "./RubricPresetUnitForm.vue?vue&type=script&lang=js"
export * from "./RubricPresetUnitForm.vue?vue&type=script&lang=js"
import style0 from "@/utils/rich_text_editor.css?vue&type=style&index=0&id=68597adf&prod&scoped=true&lang=css&external"
import style1 from "./RubricPresetUnitForm.vue?vue&type=style&index=1&id=68597adf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68597adf",
  null
  
)

export default component.exports